/* ==========================================================================
   B2B — CADASTRO DE REPRESENTANTE COMERCIAL
   1) Mapa: acende o estado sob o cursor, o pino correspondente e a legenda.
   2) Formulário: grava direto na tabela `sales_reps` do Supabase via REST.

   A URL e a anon key vêm de data-attributes no <form> (a section as imprime),
   não daqui — assim o asset continua genérico. A anon key é pública por
   design; quem protege a tabela é a RLS, que só libera INSERT.
   ========================================================================== */
(function () {
  'use strict';

  /* Três sections desta página (hero, mapa e formulário) carregam este mesmo
     arquivo, porque cada uma precisa funcionar sozinha se alguém a usar em
     outro lugar. O navegador BAIXA uma vez, mas EXECUTA uma vez por tag
     <script> — sem esta trava o corpo inteiro roda três vezes. Foi o que fez o
     cadastro gravar em triplicata na sales_reps. */
  if (window.sdnB2bRepCarregado) return;
  window.sdnB2bRepCarregado = true;

  /* ---------------------------------------------------------------- mapa */
  function iniciarMapa(raiz) {
    if (raiz.dataset.repMapaPronto) return;

    var svg = raiz.querySelector('.sdn-rep-mapa__svg');
    var legendaTitulo = raiz.querySelector('[data-mapa-titulo]');
    var legendaTexto = raiz.querySelector('[data-mapa-texto]');
    if (!svg || !legendaTitulo || !legendaTexto) return;

    raiz.dataset.repMapaPronto = '1';

    var padraoTitulo = legendaTitulo.textContent;
    var padraoTexto = legendaTexto.textContent;
    var ativo = null;

    function acender(estado) {
      if (ativo === estado) return;
      apagar();
      ativo = estado;
      estado.classList.add('is-active');
      var pino = svg.querySelector('[data-pin="' + estado.getAttribute('data-uf') + '"]');
      if (pino) pino.classList.add('is-active');
      legendaTitulo.textContent = estado.getAttribute('data-nome');
      legendaTexto.textContent = 'Território em análise de abertura';
    }

    function apagar() {
      if (!ativo) return;
      ativo.classList.remove('is-active');
      var pino = svg.querySelector('[data-pin="' + ativo.getAttribute('data-uf') + '"]');
      if (pino) pino.classList.remove('is-active');
      ativo = null;
      legendaTitulo.textContent = padraoTitulo;
      legendaTexto.textContent = padraoTexto;
    }

    // Delegação: são 27 paths, um listener no <svg> resolve todos.
    svg.addEventListener('mouseover', function (evento) {
      var estado = evento.target.closest('.sdn-rep-mapa__uf');
      if (estado) acender(estado);
    });
    svg.addEventListener('mouseleave', apagar);

    // Sem foco por teclado de propósito: 27 paradas de tab numa ilustração
    // atrapalham a navegação. Cada estado tem <title>, que é o que o leitor
    // de tela anuncia, e o conteúdo real (27 territórios) está no texto ao lado.
  }

  /* ----------------------------------------------------------- formulário */
  function iniciarFormulario(form) {
    /* Segunda linha de defesa da mesma armadilha: o editor de tema dispara
       shopify:section:load e chamaria esta função de novo no MESMO formulário,
       somando outro listener de submit — outra linha por envio. */
    if (form.dataset.repPronto) return;

    var url = form.getAttribute('data-supabase-url');
    var chave = form.getAttribute('data-supabase-key');
    var tabela = form.getAttribute('data-supabase-table') || 'sales_reps';
    if (!url || !chave) {
      console.error('[sdn-b2b-rep] faltou data-supabase-url/key no formulário.');
      return;
    }

    form.dataset.repPronto = '1';

    var raiz = form.closest('.sdn-rep-form');
    var caixaErro = form.querySelector('[data-rep-erro]');
    var caixaOk = raiz ? raiz.querySelector('[data-rep-ok]') : null;
    var botao = form.querySelector('[data-rep-enviar]');
    var rotuloBotao = botao ? botao.textContent : 'Enviar';

    function valor(campo) {
      var el = form.elements[campo];
      return el ? el.value.trim() : '';
    }

    function falhar(mensagem) {
      caixaErro.textContent = mensagem;
      caixaErro.hidden = false;
      caixaErro.scrollIntoView({ block: 'nearest' });
    }

    // O botão desabilitado não impede um segundo submit: Enter dentro de um
    // campo dispara o evento direto, sem passar pelo botão.
    var enviando = false;

    function liberar() {
      enviando = false;
      botao.disabled = false;
      botao.textContent = rotuloBotao;
    }

    form.addEventListener('submit', function (evento) {
      evento.preventDefault();
      if (enviando) return;
      caixaErro.hidden = true;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      // Colunas exatamente como a tabela `sales_reps` espera. Campo vazio vira
      // null em vez de "" — assim o comercial filtra por preenchido de verdade.
      var carga = {
        name: valor('name'),
        email: valor('email'),
        phone: valor('phone'),
        cpf_cnpj: valor('cpf_cnpj') || null,
        city: valor('city') || null,
        state: valor('state') || null,
        regions: valor('regions') || null,
        experience: valor('experience') || null,
        has_portfolio: valor('has_portfolio') || null,
        message: valor('message') || null,
        // O popup de lojista grava nesta mesma tabela; `origem` separa os dois.
        origem: 'representante'
      };

      enviando = true;
      botao.disabled = true;
      botao.textContent = 'Enviando...';

      fetch(url.replace(/\/$/, '') + '/rest/v1/' + tabela, {
        method: 'POST',
        headers: {
          apikey: chave,
          Authorization: 'Bearer ' + chave,
          'Content-Type': 'application/json',
          Prefer: 'return=minimal'
        },
        body: JSON.stringify(carga)
      })
        .then(function (resposta) {
          liberar();
          if (!resposta.ok) {
            return resposta.text().then(function (corpo) {
              console.error('[sdn-b2b-rep]', resposta.status, corpo);
              falhar('Não foi possível enviar. Tente novamente.');
            });
          }
          form.reset();

          // Mesma regra do popup de lojista: dispara no sucesso real, não no
          // clique. Tabela diferente, então content_category diferente.
          if (window.sdnB2bTrack) {
            window.sdnB2bTrack('Lead', {
              content_name: 'B2B — Cadastro de representante',
              content_category: 'representante'
            });
          }

          if (caixaOk) {
            form.hidden = true;
            caixaOk.hidden = false;
            caixaOk.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        })
        .catch(function (erro) {
          liberar();
          console.error('[sdn-b2b-rep]', erro);
          falhar('Erro de conexão. Verifique sua internet e tente novamente.');
        });
    });

    // "Novo cadastro" no estado de sucesso devolve o formulário limpo.
    if (caixaOk) {
      var voltar = caixaOk.querySelector('[data-rep-novo]');
      if (voltar) {
        voltar.addEventListener('click', function () {
          caixaOk.hidden = true;
          form.hidden = false;
          form.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      }
    }
  }

  function iniciar() {
    document.querySelectorAll('.sdn-rep-mapa').forEach(iniciarMapa);
    document.querySelectorAll('[data-rep-form]').forEach(iniciarFormulario);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // O editor de tema recria a section sem recarregar a página.
  document.addEventListener('shopify:section:load', function (evento) {
    var alvo = evento.target;
    if (alvo.querySelector('.sdn-rep-mapa')) alvo.querySelectorAll('.sdn-rep-mapa').forEach(iniciarMapa);
    alvo.querySelectorAll('[data-rep-form]').forEach(iniciarFormulario);
  });
})();
